import React from 'react';
import { DashboardPrimaryActionButton } from '../components/dashboard';
import { renderMaintTag, renderServiceTag } from './statusTags';

export default function ForkliftMobileCard({
  forklift,
  navigate,
  onSelect,
  selected,
  maintenancePathBase = '/customer/maintenance',
  missingUnitLabel = '—',
}) {
  const unitId = forklift.unitId || missingUnitLabel;
  return (
    <article
      className={`customer-preview-forklift-card shared-selected-card${selected ? ' is-selected' : ''}`}
      onClick={onSelect}
    >
      <div className="customer-preview-forklift-card-header">
        {forklift.unitId ? (
          <DashboardPrimaryActionButton
            type="link"
            className="customer-preview-unit-link customer-preview-forklift-unit-link"
            onClick={() =>
              navigate(
                `${maintenancePathBase}?unitId=${encodeURIComponent(forklift.unitId)}`
              )
            }
          >
            {unitId}
          </DashboardPrimaryActionButton>
        ) : (
          <span className="customer-preview-forklift-unit-missing">{unitId}</span>
        )}
        <div className="customer-preview-forklift-badges">
          {renderServiceTag(forklift.status)}
          {renderMaintTag(forklift.maintenanceStatus)}
        </div>
      </div>
      <dl className="customer-preview-forklift-details">
        <div>
          <dt>Make / Model</dt>
          <dd>{[forklift.make, forklift.model].filter(Boolean).join(' / ') || '—'}</dd>
        </div>
        <div>
          <dt>Serial #</dt>
          <dd>{forklift.serialNumber || '—'}</dd>
        </div>
        <div>
          <dt>Hours</dt>
          <dd>{forklift.hourMeter || forklift.hourMeter === 0 ? forklift.hourMeter : '—'}</dd>
        </div>
      </dl>
    </article>
  );
}
